export const Questions = [
	{
	  question: 'What is crowdsourcing and how does it work?',
	  answer: 'Crowdsourcing is obtaining informations that can be used to input for a tasks. It is very helpful to obtain this kind of feature for an application that provides helps from the crowd or through the intelligent infomations from the community'
	},
	{
	  question: 'How do I get started with CrowdSource?',
	  answer: 'U Rescue Me support crowdsource by signing up to our website and start on filling up forms to be submitted and forwarded to authorities get an immediate action.'
	},
	{
	  question: 'How can this simple application helps other people?',
	  answer: 'By the power of internet and social media this can make a lots of important infomations to be gathered on a simple file that can be easily forwarded to some authorized persons and could save more lives by just typing and submitting important informations.'
	},
	{
	  question: 'Is there any other addtional features that can be seen for this website?',
	  answer: 'We just got starting up as of the moment and looking forward to have more powerful features and user friendly web application that can be trusted by the important information of the users..'
	}
  ];